module.exports = __webpack_public_path__ + "img/65293383002203.be1cd476.png";